var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_15550)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_278_15550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 9V5H11.0001V11H9.83008L12.0001 13.17L14.1701 11H13.0001V9Z",
    fill: "#EAEEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9V3H9V9H5L12 16L19 9H15ZM12 13.17L9.83 11H11V5H13V11H14.17L12 13.17ZM5 18H19V20H5V18Z",
    fill: "#0045FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_15550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_278_15550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAttachment);
export default __webpack_public_path__ + "static/media/download-attachment.30881672.svg";
export { ForwardRef as ReactComponent };